<!--
 * @Descripttion: 日程详情
 * @Author: chenjinsheng
 * @Date: 2021-11-18 16:46:10
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-19 09:44:23
-->
<template>
    <div class="schdule-detail-dialog-container">
        <el-dialog :title="dataSource.summary" :visible.sync="dialogVisible" width="460px" :before-close="handleClose">
            <div v-loading="loading" class="schdule-container">
                <div class="schdule-item">
                    <span class="label">会议时间：</span><span class="field">{{ dataSource.dateString }}</span>
                </div>
                <div class="schdule-item">
                    <span class="label">会议室：</span><span class="field">{{ dataSource.roomInfo }}</span>
                </div>
                <div class="schdule-item">
                    <span class="label">组织人：</span><span class="field">{{ dataSource.organizer }}</span>
                </div>
                <div class="schdule-item">
                    <span class="label">参与人：</span><span class="field">{{ dataSource.displayNames }}</span>
                </div>
                <div class="schdule-item">
                    <span class="label">会议内容：</span><span class="field">{{ dataSource.description }}</span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getCalendarDetail } from "@/api";
export default {
    name: "SchduleDetailDialog",
    data() {
        return {
            dialogVisible: false,
            dataSource: {},
            loading: false,
            isVisible: false,
        };
    },
    methods: {
        show(item) {
            const { calendarId, eventId, userName } = item;
            this.dataSource = item;
            this.getCalendarDetail({
                calendarId,
                eventId,
                userName,
            });
            this.dialogVisible = true;
        },
        handleClose() {
            this.dialogVisible = false;
        },
        async getCalendarDetail(params) {
            this.loading = true;
            try {
                const { code, message, body } = await getCalendarDetail(params);
                if (code === "0000") {
                    const { displayNames, organizer, roomInfo } = body;
                    this.dataSource = {
                        ...this.dataSource,
                        displayNames,
                        organizer,
                        roomInfo,
                    };
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.schdule-detail-dialog-container {
    /deep/ {
        .el-dialog {
            border-radius: 8px;
        }
        .el-dialog__header {
            position: relative;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            text-align: center;
            padding-left: 30px;
            padding-right: 30px;
            // height: 52px;
            background: #f9f9f9;
            border-radius: 8px 8px 0px 0px;
            .el-dialog__title {
                font-size: 16px;
                color: #000000;
            }
            .el-dialog__headerbtn {
                position: absolute;
                top: 10px;
                right: 10px;
            }
        }
        .schdule-item {
            display: flex;
            flex-wrap: nowrap;
            margin-bottom: 14px;
            &:last-child {
                margin-bottom: 84px;
            }
            .label {
                display: inline-block;
                width: 100px;
                font-size: 14px;
                line-height: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
            }
            .field {
                display: inline-block;
                width: calc(100% - 70px);
                line-height: 24px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #000000;
                margin-left: 10px;
            }
        }
        .schdule-container {
            margin-bottom: 84px;
        }
    }
}
</style>
